import React, { useEffect, useState } from "react";
import { Modal } from "../shared-components/Modal";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  EllipsisHorizontalCircleIcon,
} from "@heroicons/react/24/outline";
import ReportStatus from "./ReportStatus";
import TableReportDateWithFormat from "../shared-components/TableReportDateWithFormat";
import { useGetStepRunsByRunUUID } from "../api/ReportsApi";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import { sortBy } from "lodash";

type Props = {
  workflowRunUUID: string;
};

const ReportStepsModal = (props: Props) => {
  const [isReportNoteModalOpen, setIsReportNoteModalOpen] = useState(false);
  const [showParentSteps, setShowParentSteps] = useState(false);

  const {
    isLoading: stepRunsLoading,
    data: stepRuns,
    mutate: getStepRuns,
  } = useGetStepRunsByRunUUID();

  useEffect(() => {
    if (isReportNoteModalOpen) {
      setShowParentSteps(false);
      getStepRuns(props.workflowRunUUID);
    }
  }, [getStepRuns, isReportNoteModalOpen, props.workflowRunUUID]);
  const sortedSteps = sortBy(stepRuns, (stepRun) => stepRun.created_at) ?? [];
  const steps = sortedSteps.filter((stepRun) => {
    return stepRun.workflow_run_uuid === props.workflowRunUUID;
  });

  const parentSteps = sortedSteps.filter((stepRun) => {
    return stepRun.workflow_run_uuid !== props.workflowRunUUID;
  });

  if (stepRunsLoading) return <LoadingSpinner />;

  return (
    <div>
      <EllipsisHorizontalCircleIcon
        className="w-5 h-5 text-gray-500 cursor-pointer"
        onClick={() => setIsReportNoteModalOpen(true)}
      />
      <Modal
        open={isReportNoteModalOpen}
        onClose={() => setIsReportNoteModalOpen(false)}
        width={"w-full max-w-lg p-0"}
      >
        <div>
          <h3 className="pb-4">Workflow Step History</h3>
          {parentSteps.length > 0 && (
            <div>
              <div
                className="pb-4 flex text-gray-400 justify-between underline cursor-pointer"
                onClick={() => {
                  setShowParentSteps(!showParentSteps);
                }}
              >
                Parent Steps
                <span>
                  {!showParentSteps ? (
                    <ChevronDownIcon className="h-4 w-4" />
                  ) : (
                    <ChevronUpIcon className="h-4 w-4" />
                  )}
                </span>
              </div>
              {showParentSteps && (
                <>
                  <StepTable steps={parentSteps} />
                  <hr className="block my-4"></hr>
                </>
              )}
            </div>
          )}
          <div>
            <StepTable steps={steps} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

const StepTable = (props: { steps: any[] }) => {
  return (
    <>
      <div className="flex pb-2 text-gray-500">
        <div className="w-48">Step Name</div>
        <div className="w-24">Status</div>
        <div className="">Finished at</div>
      </div>
      <div>
        {props.steps.map((step, index) => {
          return (
            <div key={index} className="flex pb-2 text-sm">
              <div className="w-48">
                <ReportStatus
                  stepStatusName={step.name}
                  failed={false}
                  allowResumeOnClick={false}
                />
              </div>
              <div className="w-24">{step.status}</div>
              <div className="text-xs">
                {step.finished_at && (
                  <TableReportDateWithFormat
                    date={step.finished_at}
                    updated={false}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ReportStepsModal;
